export default "__VITE_ASSET__5720853b__"